module.exports = __webpack_public_path__ + "static/media/minus-white.d320a3cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/minus-white.svg
// module id = 1275
// module chunks = 0